import React from "react";
import { Button } from "antd";
import { ArrowDownOutlined, CloudDownloadOutlined } from "@ant-design/icons";

interface Props {
  searchConfig: {
    [key: string]: any;
  };
  title: string;
  isSmall?: boolean;
  isDisabled?: boolean;
}

const ExportConfigButton: React.FC<Props> = ({ searchConfig, title, isSmall, isDisabled }) => {
  const exportConfigToCSV = () => {
    const rows: string[][] = [];

    // Add the first column title if provided
    if (title) {
      rows.push(["title", title]);
    }

    //   let value = obj[header];
    //   if (Array.isArray(value)) {
    //     value = value.map((item: any) => {
    //       if (typeof item === "object" && !Array.isArray(item)) {
    //         return Object.values(item).join(":");
    //       }
    //       return item;
    //     });
    //     row.push(`"${value.join(",")}"`);
    //   } else if (typeof value === "object") {
    //     row.push(`"${JSON.stringify(value)}"`);
    //   } else {
    //     row.push(String(value));
    // }

    // Extract key-value pairs from searchConfig object and add them to rows
    for (const key in searchConfig) {
      if (Object.prototype.hasOwnProperty.call(searchConfig, key)) {
        const value = searchConfig[key];
        let formattedValue: string;
        if (Array.isArray(value)) {
          // If the value is an array, stringify it
          //formattedValue = JSON.stringify(value);
          const data =
            key === "skills"
              ? value.map((item) => item.name)
              : value.map((item: any) => {
                  if (typeof item === "object" && !Array.isArray(item)) {
                    return Object.values(item).join(":");
                  }
                  return item;
                });
          formattedValue = `"${data.join(", ")}"`;
        } else if (typeof value === "object") {
          // If the value is an object, stringify it
          formattedValue = `"${JSON.stringify(value)}"`;
        } else {
          // For other types, convert to string
          formattedValue = String(value);
        }
        rows.push([key, formattedValue]);
      }
    }

    // Convert rows to CSV format
    const csvContent = rows.map((row) => row.join(",")).join("\n");

    // Create a Blob with the CSV data
    const blob = new Blob([csvContent], { type: "text/csv" });

    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a temporary anchor element to trigger the download
    const a = document.createElement("a");
    a.href = url;
    a.download = (title ? title : "") + "_search_config.csv";

    // Trigger the download
    document.body.appendChild(a);
    a.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  return (
    <Button
      type="primary"
      icon={<CloudDownloadOutlined />}
      ghost
      size={isSmall ? "small" : "middle"}
      onClick={exportConfigToCSV}
      disabled={isDisabled ?? false}
    >
      Export Search Config
    </Button>
  );
};

export default ExportConfigButton;
